import { useAppDispatch, useAppSelector } from '@/shared/hooks-tmp/reduxToolkitHooks';
import { showErrorAlert } from '@/shared/lib/showErrorAlert';
import { removeSegmentDataToSave, setStatus } from '@/shared/store-tmp/editor/EditorSlice';
import { updateSegments } from '@/shared/store-tmp/editor/thunks/updateSegments';
import { SegmentStatus, TAutoSavingSegmentData } from '@/shared/types/Editor';

import { useGetProject } from './useGetProject';

type UseUpdateAllSegmentsInEditor = {
  changedDataKey?: keyof TAutoSavingSegmentData;
};

export const useUpdateAllSegmentsInEditor = () => {
  const { data: project, refetch: refetchProject } = useGetProject();
  const segments = useAppSelector((state) => state.editor.segmentsMap);
  const dispatch = useAppDispatch();

  return async ({ changedDataKey }: UseUpdateAllSegmentsInEditor = {}) => {
    try {
      Object.keys(segments).forEach((segmentId) => {
        dispatch(setStatus({ id: segmentId, status: SegmentStatus.Processing }));
        dispatch(removeSegmentDataToSave({ changedDataKey, segmentId }));
      });

      await dispatch(
        updateSegments({
          changedData: Object.values(segments).map((segment) => ({
            id: segment.id,
            src: { ...segment.src, text: `${segment.src.text} ` },
          })),
          project,
        }),
      );

      await refetchProject();
    } catch (e) {
      showErrorAlert(e);
      throw new Error('Error updating segments');
    }
  };
};
